// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__checkbox___jfr97 {
  margin-right: 10px;
}

.styles__checkboxes___sxcJd {
  margin-top: 20px;
}

.styles__contentContainer___mUs40 {
}

.styles__form___jPrGc {
  display: flex;
  flex-flow: column nowrap;
}

.styles__formItemMono___xpHa_ {
}

.styles__formWrapper___r7gA_ {
  width: calc(99.9% * 2/3 - (30px - 30px * 2/3));
}

.styles__formWrapper___r7gA_:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__formWrapper___r7gA_:last-child {
  margin-right: 0;
}

.styles__formWrapper___r7gA_:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__formWrapper___r7gA_:nth-child(3n + 1) {
  clear: both;
}

.styles__saveButton___bK5S6 {
}

.styles__headerSection___WgMMM {
  min-height: 80px;
}

.styles__headerTitle___rB_MU {
  float: left;
}

.styles__label___GZ57W {
  color: #555;
  font-size: 13px;
}

.styles__link___WSWT0 {
  background: rgba(255, 255, 255, 0.7);
  box-shadow: none;
  display: block;
}

.styles__link___WSWT0:hover {
    background: white;
    box-shadow: none;
  }

.styles__navigationSave___xtcXN {
  float: left;
  padding-left: 5px;
  padding-top: 20px;
}

.styles__navigationMenuWrapper___I_PYN {
  position: fixed;
  width: 452.86px;
}

@media (max-width: 1440px) {

.styles__navigationMenuWrapper___I_PYN {
    max-width: 31%;
    right: 20px;
}
  }

.styles__row___bUZPw {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.styles__section___B2rdf {
}

.styles__sectionNoMargin___oafWP {
}

.styles__accountExtrasSection___Z2Eq6 {
  padding: 0;
}

.styles__input___v7D4g {
}

.styles__label___GZ57W {
}

.styles__emailGroup___xRSZv .styles__input___v7D4g {
  float: left;
  width: 50%;
}

.styles__emailGroup___xRSZv .styles__label___GZ57W {
  font-size: 15px;
  float: right;
  width: 45%;
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/CoTrustee/components/User/components/Edit/styles.css"],"names":[],"mappings":"AAIA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;AAEA;;AAEA;EACE,aAA2B;EAA3B,wBAA2B;AAC7B;;AAEA;AAEA;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;AAEA;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAEhB,cAAc;AAMhB;;AAJE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;AAGF;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;AAMjB;;AAJE;;AAJF;IAKI,cAAc;IACd,WAAW;AAEf;EADE;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,UAAU;AACZ;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtGray, gtGrayMid, gtGreen, gtBlue from colors;\n\n.checkbox {\n  margin-right: 10px;\n}\n\n.checkboxes {\n  margin-top: 20px;\n}\n\n.contentContainer {\n  composes: content-container from helpers;\n}\n\n.form {\n  lost-flex-container: column;\n}\n\n.formItemMono {\n  composes: formItemMono from helpers;\n}\n\n.formWrapper {\n  lost-column: 2/3;\n}\n\n.saveButton {\n  composes: button from helpers;\n}\n\n.headerSection {\n  composes: section from helpers;\n  min-height: 80px;\n}\n\n.headerTitle {\n  float: left;\n}\n\n.label {\n  composes: label from helpers;\n  color: #555;\n  font-size: 13px;\n}\n\n.link {\n  background: rgba(255, 255, 255, 0.7);\n  box-shadow: none;\n  composes: sectionTitle from helpers;\n  display: block;\n\n  &:hover {\n    background: white;\n    box-shadow: none;\n  }\n}\n\n.navigationSave {\n  float: left;\n  padding-left: 5px;\n  padding-top: 20px;\n}\n\n.navigationMenuWrapper {\n  position: fixed;\n  width: 452.86px;\n\n  @media (max-width: 1440px) {\n    max-width: 31%;\n    right: 20px;\n  }\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.section {\n  composes: section from helpers;\n}\n\n.sectionNoMargin {\n  composes: sectionNoMargin from helpers;\n}\n\n.accountExtrasSection {\n  composes: sectionNoMargin;\n  padding: 0;\n}\n\n.input {\n  composes: input from helpers;\n}\n\n.label {\n  composes: label from helpers;\n}\n\n.emailGroup .input {\n  float: left;\n  width: 50%;\n}\n\n.emailGroup .label {\n  font-size: 15px;\n  float: right;\n  width: 45%;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtGrayMid": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayMid"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"checkbox": `styles__checkbox___jfr97`,
	"checkboxes": `styles__checkboxes___sxcJd`,
	"contentContainer": `styles__contentContainer___mUs40 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"form": `styles__form___jPrGc`,
	"formItemMono": `styles__formItemMono___xpHa_ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItemMono"]}`,
	"formWrapper": `styles__formWrapper___r7gA_`,
	"saveButton": `styles__saveButton___bK5S6 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"headerSection": `styles__headerSection___WgMMM ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"headerTitle": `styles__headerTitle___rB_MU`,
	"label": `styles__label___GZ57W ${___CSS_LOADER_ICSS_IMPORT_1___.locals["label"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["label"]}`,
	"link": `styles__link___WSWT0 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"navigationSave": `styles__navigationSave___xtcXN`,
	"navigationMenuWrapper": `styles__navigationMenuWrapper___I_PYN`,
	"row": `styles__row___bUZPw`,
	"section": `styles__section___B2rdf ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"sectionNoMargin": `styles__sectionNoMargin___oafWP ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"accountExtrasSection": `styles__accountExtrasSection___Z2Eq6 styles__sectionNoMargin___oafWP ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"input": `styles__input___v7D4g ${___CSS_LOADER_ICSS_IMPORT_1___.locals["input"]}`,
	"emailGroup": `styles__emailGroup___xRSZv`
};
export default ___CSS_LOADER_EXPORT___;
